import React, { useState, useEffect } from "react";
import API from "../api/axiosInstance";

// Define Job Type
interface Job {
    JobID: string;
    Institution?: { Name: string };
    Status: string;
    AssignedProcessor?: { ServiceName: string };
    Priority: number;
    LastUpdated: string;
}

const TenantJobMonitoring: React.FC = () => {
    const [jobs, setJobs] = useState<Job[]>([]);

    useEffect(() => {
        fetchJobs();
        const interval = setInterval(fetchJobs, 60000);
        return () => clearInterval(interval);
    }, []);

    const fetchJobs = async () => {
        const response = await API.get("/processing/tenant-jobs");
        setJobs(response.data);
    };

    return (
        <div>
            <h3>My Report Jobs</h3>
            <table>
                <thead>
                    <tr>
                        <th>Job ID</th>
                        <th>Status</th>
                        <th>Priority</th>
                        <th>Last Update</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {jobs.map((job) => (
                        <tr key={job.JobID}>
                            <td>{job.JobID}</td>
                            <td>{job.Status}</td>
                            <td>{job.Priority}</td>
                            <td>{new Date(job.LastUpdated).toLocaleString()}</td>
                            <td>
                                {job.Status !== "IN_PROGRESS" && <button onClick={() => API.post("/processing/requeue-job", { JobID: job.JobID })}>Requeue</button>}
                                {job.Status !== "COMPLETED" && <button onClick={() => API.post("/processing/cancel-job", { JobID: job.JobID })}>Delete</button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TenantJobMonitoring;
